// extracted by mini-css-extract-plugin
module.exports = {"dropdownMenu":"Autosuggest_dropdownMenu__1LEQU"};